module.exports = __webpack_public_path__ + "static/media/pause-circle.10992783.svg";